import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";

import { getErrorText } from "../utils/errors";
import { globalStyles } from "../utils/styles";
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
  const error = useRouteError() as any;
  const { t } = useTranslation("ErrorPage");
  const navigate = useNavigate();
  return (
    <Box>
      <Typography variant="h4">{t("title")}</Typography>
      <Typography variant="body1" sx={globalStyles.gapTop}>
        {t("body")}
      </Typography>
      <Typography variant="errorBody">{getErrorText(error)}</Typography>
      <Box sx={globalStyles.gapTop}>
        <Button variant="outlined" onClick={() => navigate("/")}>
          {t("goHome")}
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorPage;
